module.exports = __webpack_public_path__ + "img/LineIconsPro Light.c1c0922.svg";